module.exports = __webpack_public_path__ + "static/media/photo.7d13023b.png";